import RoulettePro from './components/Roulette';
import type {
  IDesignPluginProps,
  IDesignPlugin,
  PrizeType,
  RouletteType,
} from './types';

export default RoulettePro;

export { IDesignPluginProps, IDesignPlugin, PrizeType, RouletteType };
